import { JSX, ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Button from "@/components/buttons/Button.tsx";
import { IconSplay } from "@/components/icons";

interface ErrorProps {
  type: 404 | 500;
  title: string | ReactNode;
  description: string;
}

const Error = ({ type = 404, title, description }: ErrorProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Что-то пошло не так!`}</title>
        <meta name="description" content={description} />
      </Helmet>
      <div
        className={"relative flex min-h-screen flex-col items-center justify-between overflow-hidden py-10 max-lg:p-0"}
      >
        <IconSplay className={"h-10 fill-orange-1 max-lg:invisible"} />
        <div
          className={
            "relative z-[1] flex max-w-[30.6rem] flex-col items-center gap-10 text-center max-lg:max-w-[21.4rem]"
          }
        >
          <div className={"space-y-6"}>
            <h1 className={"text-[6.25rem]/[7.5rem] font-bold max-lg:text-[4rem]/[4.5rem]"}>{type}</h1>
            <div className={"space-y-4"}>
              <h2 className={"text-[3.125rem]/[3.75rem] font-semibold max-lg:text-2xl"}>{title}</h2>
              <p className={"text-lg/tight max-lg:text-base"}>{description}</p>
            </div>
          </div>
          <Link to={"/"}>
            <Button className={"px-[2.906rem] py-[1.375rem] uppercase max-lg:px-7 max-lg:py-4"}>
              {t("navigation.go-back-to-home")}
            </Button>
          </Link>
        </div>
        <div />
        <div
          className={
            "absolute left-1/2 top-1/2 h-[25em] w-[25rem] -translate-x-1/2 -translate-y-1/2 bg-orange-1 opacity-50 blur-[200px]"
          }
        />
      </div>
    </>
  );
};

export default Error;
